// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pawniard: PokeData = {
  "id": 624,
  "name": "pawniard",
  "height": 5,
  "weight": 102,
  "base_experience": 68,
  "types": [
    PokeType.DARK,
    PokeType.STEEL
  ],
  "api_moves": [
    "scratch",
    "guillotine",
    "swords-dance",
    "leer",
    "slash",
    "scary-face",
    "feint-attack",
    "fury-cutter",
    "metal-claw",
    "torment",
    "metal-sound",
    "iron-defense",
    "assurance",
    "embargo",
    "night-slash",
    "iron-head",
    "retaliate",
    "laser-focus"
  ],
  "moves": [
    "scratch",
    "leer",
    "scary-face",
    "metal-claw",
    "metal-sound",
    "night-slash",
    "scrap-throw",
    "quash",
    "dark-pulse",
    "pursuit",
    "flatter",
    "crunch",
    "dark-bargain"
  ],
  "evolution_chain": {
    "id": 317,
    "item": null,
    "species": [
      {
        "name": "pawniard",
        "order": 625,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bisharp",
        "order": 626,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 624,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 52,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kingambit",
        "order": 1008,
        "types": [
          PokeType.DARK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 625,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 60,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
